module.exports = __webpack_public_path__ + "img/logo-mini.d5758094.png";